const languages = {
    en: {
        home_title: "Shandong Xin Hua Technology Co.Ltd",
        // 导航栏
        home_home: "Home",
        home_product: "Product Center",
        home_service: "Intelligent solution",
        home_success: "Success Cases",
        home_technology: "Technical Support",
        home_news: "News Center",
        news_detail: "News Detail",
        news_list: "Return to List",
        home_about: "About Us",
        home_aboutus: "Innovation, Professionalism, And Trustworthiness",
        aboutUs: "Enterprise Honor and Style",
        // 首页面
        homePage_us: "Contact Us",
        homePage_mos: "View Details",
        homePage_now: "Consult Now",
        homePage_site: "Site Navigation",
        homePage_more: "See More",
        homePage_cases: "Successful Service Cases",
        homePage_title: "Shandong Xin Hua Technology Co.Ltd",
        homePage_content: "Introduction Introduction Introduction Introduction Introduction ",
        homePage_product: "A DOMESTICALLY LEADING, COMPLETE, MATURE PRODUCT SYSTEM THAT COVERS THE ENTIRE BUSINESS PROCESS.",
        homePage_product1: "国内领先、成套、成熟、覆盖全业务流程的产品体系",
        homePage_product_P1: "Intelligent equipment and products",
        homePage_product_P2: "Intelligent instruments and valves",
        homePage_product_P3: "Internet platform and software",
        homePage_product_div: "<p>Introduction Introduction Introduction Introduction Introduction</p>Introduction Introduction Introduction Introduction Introduction",
        homePage_scheme_p1: "INTELLIGENT SOLUTIONS",
        homePage_scheme_p2: "智能解决方案",
        homePage_scheme_title: "Black",

        project_all: "All",
        project_1: "Intelligent manufacturing products",
        project_2: "industrial automation equipment",
        project_3: "IoT solutions",
        wechat: "Wechat",
        gongzh: "Official",
        contact: "Phone",
        test: "test"
    },
    zh: {
        home_title: "山东鑫华技术有限公司",
        // 导航栏
        home_home: "首页",
        home_product: "产品中心",
        home_service: "智能化解决方案",
        home_success: "成功案例",
        home_technology: "技术支持",
        home_news: "新闻中心",
        news_detail: "新闻详情",
        news_list: "返回列表",
        home_about: "关于我们",
        home_aboutus: "创新 · 专业 · 值得信赖",
        aboutUs: "企业荣誉与风采",
        // 首页面
        homePage_us: "联系我们",
        homePage_now: "立即咨询",
        homePage_site: "网站导航",
        homePage_more: "查看更多",
        homePage_mos: "查看详情",
        homePage_cases: "服务成功案例",





        homePage_title: "山东鑫华技术有限公司",
        homePage_content: "宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介",
        homePage_product: "国内领先、成套、成熟、覆盖全业务流程的产品体系",
        homePage_product1: "A DOMESTICALLY LEADING, COMPLETE, MATURE PRODUCT SYSTEM THAT COVERS THE ENTIRE BUSINESS PROCESS.",
        homePage_product_P1: "智能化装备与产品",
        homePage_product_P2: "智能仪表及阀门",
        homePage_product_P3: "互联网平台及软件",
        homePage_product_div: "<p>宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介</p>宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介",
        homePage_scheme_p1: "智能解决方案",
        homePage_scheme_p2: "INTELLIGENT SOLUTIONS",
        homePage_scheme_title: "黑色",


        project_all: "全部",
        project_1: "智能制造产品",
        project_2: "工业自动化设备",
        project_3: "物联网解决方案",
        wechat: "微信",
        gongzh: "公众号",
        contact: "联系电话",
        test: "服务企业"
    }
};

export default languages;



// WEBPACK FOOTER //
// ./src/assets/js/languages/languages.js